import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface ShortcutConfig {
  enabled?: boolean;
}

export const useKeyboardShortcuts = ({ enabled = true }: ShortcutConfig = {}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      // Don't trigger if user is typing in an input
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement ||
        (e.target as HTMLElement).isContentEditable
      ) {
        return;
      }

      const isCtrl = e.ctrlKey || e.metaKey;

      // Ctrl+N - Add new student
      if (isCtrl && e.key === "n") {
        e.preventDefault();
        navigate("/students/add");
      }

      // Ctrl+Shift+A - Go to attendance
      if (isCtrl && e.shiftKey && e.key === "A") {
        e.preventDefault();
        navigate("/attendance/student");
      }

      // Ctrl+Shift+D - Go to dashboard
      if (isCtrl && e.shiftKey && e.key === "D") {
        e.preventDefault();
        navigate("/dashboard");
      }

      // Ctrl+Shift+S - Go to student list
      if (isCtrl && e.shiftKey && e.key === "S") {
        e.preventDefault();
        navigate("/students");
      }

      // ? key - Show shortcuts help (could be expanded)
      if (e.key === "?" && !isCtrl) {
        // This could open a shortcuts modal in the future
        console.log("Keyboard shortcuts: Ctrl+K (Search), Ctrl+N (New Student), Ctrl+Shift+D (Dashboard), Ctrl+Shift+S (Students), Ctrl+Shift+A (Attendance)");
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [enabled, navigate]);
};

export const shortcuts = [
  { keys: ["⌘", "K"], description: "Open search" },
  { keys: ["⌘", "N"], description: "Add new student" },
  { keys: ["⌘", "⇧", "D"], description: "Go to dashboard" },
  { keys: ["⌘", "⇧", "S"], description: "Go to student list" },
  { keys: ["⌘", "⇧", "A"], description: "Go to attendance" },
];
